import { useEffect } from "react";
import { Graph } from "../graph/Graph";
import { Interval } from "../navigation/tabs/TabsTypes";
import { GraphType } from "../graph/GraphTypes";
import { timestampToDate } from "../helpers/DateHelper";
import classes from "./VpInAreaStats.module.css";
import i18n from "../i18n";

interface VPProps {
  startDate: number;
  endDate: number;
  serial: string;
  title: string;
}

export const VpInAreaStats = ({ startDate, endDate, serial, title }: VPProps) => {
  useEffect(() => {
    const timer = setInterval(() => {
      console.log("[VpInAreaStats] Refetching data every 15 seconds");
    }, 15000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* Per‑Hour view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("VpInAreaAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerHour")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.HOUR}
            graphType={GraphType.VPINAREA_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

      {/* Per‑Day view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("VpInAreaAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerDay")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.DAY}
            graphType={GraphType.VPINAREA_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

    </>
  );
};
